import { render, staticRenderFns } from "./SearchPageList.vue?vue&type=template&id=54a8e412&"
import script from "./SearchPageList.vue?vue&type=script&lang=js&"
export * from "./SearchPageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/joelstorm/Sites/hanken-sse-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('54a8e412', component.options)
    } else {
      api.reload('54a8e412', component.options)
    }
    module.hot.accept("./SearchPageList.vue?vue&type=template&id=54a8e412&", function () {
      api.rerender('54a8e412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/SearchPageList.vue"
export default component.exports